<template>
  <v-dialog
    v-model="open"
    :width="isMobileBreakpoint ? '100%' : '964px'"
    :fullscreen="isMobileBreakpoint"
    scrollable
  >
    <v-card dense class="mt-0">
      <v-toolbar
        elevation="0"
        :class="isMobileBreakpoint ? 'px-2' : ''"
        :style="isMobileBreakpoint ? 'max-height: 56px !important' : ''"
      >
        <v-toolbar-title
          v-if="!paymentStep"
          style="padding-left: 10px"
          class="titleText newTitle--text"
        >
          {{ $t('message.pages.credits.creditsBuyModal.title') }}
        </v-toolbar-title>
        <v-icon
          v-if="paymentStep && !pendingPayment && !paymentDone"
          style="cursor: pointer"
          :class="`primary--text ${isMobileBreakpoint ? '' : 'ml-2'}`"
          @click="paymentStep = false"
        >
          mdi-arrow-left
        </v-icon>
        <h4
          v-if="paymentStep && !pendingPayment && !paymentDone"
          class="textType--text ml-2"
        >
          {{ $t('message.pages.credits.creditsBuyModal.confirmPayment') }}
        </h4>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn v-if="!paymentStep || paymentDone" icon @click="handleClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text
        class="pa-0"
        :class="[paymentStep ? 'pa-0' : 'pb-4 px-7']"
        :style="`${
          isMobileBreakpoint ? 'height: 100% !important;' : 'max-height: 510px;'
        } overflow: visible; overflow-y: auto`"
      >
        <v-row
          v-if="errors.fetchError"
          no-gutters
          class="pt-8"
          :class="
            radioCardValue === 'boleto' || radioCardValue === 'card'
              ? 'mt-16'
              : ''
          "
          style="height: 420px !important"
        >
          <v-col cols="12">
            <v-row
              class="flex-column"
              :class="isMobileBreakpoint ? '' : 'px-11'"
              no-gutters
              align="center"
              justify="center"
            >
              <v-icon size="64" color="#F44336" class="mt-5 mb-2'">
                mdi-close-octagon
              </v-icon>
              <span class="paymentText textType2--text">
                {{ $t('message.pages.credits.creditsBuyModal.paymentError') }}
              </span>
              <span class="dateText textType--text">
                Em {{ formattedTime }}
              </span>
              <span
                class="paymentCodeText textType2--text mt-1"
                :class="isMobileBreakpoint ? 'mb-2' : ''"
              >
                {{
                  $t('message.pages.credits.creditsBuyModal.youTried')
                    .replace('XXX', creditValue)
                    .replace(
                      'XXX',
                      formatCurrency(originalCustomValue || creditValue)
                    )
                }}
              </span>
              <v-btn
                class="mt-5"
                elevation-0
                color="primary"
                @click="handleBackToPayment"
              >
                {{ $t('message.pages.credits.creditsBuyModal.tryAgain') }}
              </v-btn>
              <span
                class="px-5 mt-3 primary--text creditHistoryText"
                @click="handleCreditsHistory"
                style="cursor: pointer"
                >{{
                  $t('message.pages.credits.creditsBuyModal.creditsHistory')
                }}</span
              >
            </v-row>
          </v-col>
        </v-row>
        <v-row
          v-else-if="
            (pendingPayment || paymentDone) && !loadings.brazilPayments
          "
          no-gutters
          :class="
            radioCardValue === 'boleto' || radioCardValue === 'card'
              ? 'mt-16 pt-8'
              : 'pt-4'
          "
          :style="
            radioCardValue === 'pix'
              ? 'height: 480px !important'
              : 'height: 420px !important'
          "
        >
          <v-col cols="12">
            <v-row
              class="flex-column"
              :class="isMobileBreakpoint ? '' : 'px-11'"
              no-gutters
              align="center"
              justify="center"
            >
              <v-icon
                size="64"
                color="#4CAF50"
                :class="radioCardValue === 'card' ? 'mt-5 mb-2' : ''"
                >mdi-check-circle</v-icon
              >
              <span
                class="paymentText textType2--text"
                v-if="radioCardValue === 'card'"
              >
                {{ $t('message.pages.credits.creditsBuyModal.paymentSuccess') }}
              </span>
              <span v-else class="paymentText textType2--text">
                {{
                  $t('message.pages.credits.creditsBuyModal.solicitedCredits')
                    .replace('XXX', creditValue)
                    .replace(
                      'YYY',
                      formatCurrency(originalCustomValue || creditValue)
                    )
                }}
              </span>
              <span class="dateText textType--text">
                {{ $t('message.pages.credits.creditsBuyModal.on') }}
                {{ formattedTime }}
              </span>
              <v-col
                v-if="!loadings.brazilPayments"
                cols="12"
                class="d-flex flex-row align-center justify-center"
              >
                <img
                  style="height: 175px"
                  v-if="radioCardValue === 'pix'"
                  :src="qrCodeSource"
                />
              </v-col>
              <span
                class="paymentCodeText textType2--text mt-3"
                :class="isMobileBreakpoint ? 'mb-2' : ''"
                v-html="
                  radioCardValue === 'pix'
                    ? $t('message.pages.credits.creditsBuyModal.qrcodeText')
                    : radioCardValue === 'boleto'
                    ? $t('message.pages.credits.creditsBuyModal.boletoText')
                    : $t('message.pages.credits.creditsBuyModal.buyCredits')
                        .replace('XXX', creditValue)
                        .replace(
                          'YYY',
                          formatCurrency(originalCustomValue || creditValue)
                        )
                "
              >
              </span>
              <v-col
                cols="12"
                class="d-flex align-center justify-center my-4"
                v-if="radioCardValue !== 'card' && !loadings.brazilPayments"
              >
                <v-text-field
                  v-model="paymentText"
                  append-icon="mdi-content-copy"
                  style="max-width: 350px"
                  outlined
                  @click:append="handleCopyPaymentCode"
                  @click="handleCopyPaymentCode"
                  color="primary"
                  readonly
                  hide-details
                ></v-text-field>
              </v-col>
              <v-btn
                v-if="radioCardValue === 'boleto'"
                class="mt-5"
                elevation-0
                color="primary"
                @click="handleOpenBoletoPdf"
                >{{ $t('message.pages.credits.creditsPaymentModal.seeBoleto') }}
                <v-icon size="16" color="white" class="ml-1"
                  >mdi-open-in-new</v-icon
                >
              </v-btn>
              <base-btn
                v-if="
                  radioCardValue !== 'card' &&
                  !loadings.brazilPayments &&
                  radioCardValue !== 'boleto'
                "
                class="mb-3"
                @click="handleCopyPaymentCode"
              >
                <v-icon size="16" color="primary">mdi-content-copy</v-icon>
                {{ $t('message.pages.credits.creditsPaymentModal.copyCode') }}
              </base-btn>
              <span
                v-if="
                  (pendingPayment || paymentDone) &&
                  !loadings.brazilPayments &&
                  radioCardValue === 'card'
                "
                class="px-5 mt-3 primary--text creditHistoryText"
                @click="handleCreditsHistory"
                style="cursor: pointer"
                >{{
                  $t('message.pages.credits.creditsBuyModal.creditsHistory')
                }}</span
              >
            </v-row>
          </v-col>
        </v-row>
        <v-row
          v-else-if="paymentStep"
          no-gutters
          :style="`border-top: 1px solid ${
            $vuetify.theme.dark ? '#363949' : '#edeef1'
          }`"
        >
          <v-col cols="12" :style="`height: 420px !important;`">
            <v-row no-gutters style="height: 100% !important">
              <v-col
                :cols="isMobileBreakpoint ? 12 : 4"
                :class="`${isMobileBreakpoint ? 'px-2 mr-8' : 'px-6'}`"
                :style="`${isMobileBreakpoint ? '' : 'padding-top: 100px;'} ${
                  $vuetify.theme.dark
                    ? 'background-color: #051161;'
                    : 'background-color: #F8F9FF;'
                } ${isMobileBreakpoint ? 'order: 2;' : 'order: 1;'}`"
              >
                <v-row
                  no-gutters
                  class="align-center justify-center mb-6"
                  :class="`${isMobileBreakpoint ? 'px-6' : ''}`"
                >
                  <v-col cols="12" class="d-flex align-center justify-center">
                    <v-card flat>
                      <v-row no-gutters>
                        <div
                          class="pt-1"
                          :style="
                            $vuetify.theme.dark
                              ? 'background-color: #051161'
                              : 'background-color: #F8F9FF'
                          "
                        >
                          <v-row no-gutters class="align-center justify-center">
                            <v-img
                              class="pb-1"
                              height="24"
                              width="24"
                              src="@/assets/credit_buy_modal_icon.svg"
                              contain
                            />
                            <span class="ml-1 pt-2">
                              <span class="creditsPrice text-center">{{
                                creditValue.toLocaleString('pt-BR')
                              }}</span>
                              <br />
                              <span class="creditsTextPrice text-center">{{
                                $t(
                                  'message.pages.credits.creditsBuyModal.credits'
                                )
                              }}</span>
                            </span>
                          </v-row>
                        </div>
                      </v-row>
                    </v-card>
                  </v-col>

                  <v-col cols="12" class="my-3">
                    <v-divider />
                  </v-col>

                  <v-col cols="12" class="d-flex justify-space-between mb-2">
                    <span class="textType7--text">
                      {{ $t('message.pages.credits.creditsBuyModal.subtotal') }}
                    </span>
                    <span class="textType--text">{{
                      formatCurrency(originalCustomValue || creditValue)
                    }}</span>
                  </v-col>

                  <v-col
                    v-if="customValueDiscount"
                    cols="12"
                    class="d-flex justify-space-between mb-2"
                  >
                    <span class="textType7--text"
                      >{{
                        $t('message.pages.credits.creditsBuyModal.discountName')
                      }}
                      ({{ customValueDiscount }})</span
                    >
                    <span
                      >-{{
                        formatCurrency(
                          originalCustomValue - discountedCustomValue
                        )
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" class="my-3">
                    <v-divider />
                  </v-col>

                  <v-col cols="12" class="d-flex justify-space-between">
                    <span class="textType--text font-weight-medium">Total</span>
                    <span class="textType--text font-weight-medium">{{
                      formatCurrency(discountedCustomValue)
                    }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-if="isMobileBreakpoint"
                style="order: 3"
                cols="12"
                class="d-flex flex-column align-center justify-center mt-3"
              >
                <base-btn
                  class="mt-4"
                  style="width: 200px"
                  color="#3F55EE"
                  :disabled="loadings.saveCredits"
                  :loading="loadings.saveCredits"
                  @click="handleAddCredit"
                >
                  <span>{{
                    $t('message.pages.credits.creditsBuyModal.confirmPayment')
                  }}</span>
                </base-btn>
                <span class="nonRefundableText textType10--text mt-2">
                  {{
                    $t('message.pages.credits.creditsBuyModal.nonRefundable')
                  }}
                </span>
              </v-col>
              <v-col
                :cols="isMobileBreakpoint ? 12 : 8"
                :class="`${isMobileBreakpoint ? 'px-2' : 'pl-8'}`"
                :style="`${isMobileBreakpoint ? 'order: 1;' : 'order: 2;'}`"
              >
                <v-row no-gutters class="flex-column">
                  <v-col cols="12" class="mt-6">
                    <span class="paymentMethodText textType10--text">{{
                      $t('message.pages.credits.creditsBuyModal.paymentMethod')
                    }}</span>
                  </v-col>
                  <v-col
                    v-if="!userSources.length"
                    cols="12"
                    class="d-flex flex-row align-center justify-center mt-8"
                  >
                    <v-progress-circular
                      :size="32"
                      width="3"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </v-col>
                  <v-col cols="12" v-else>
                    <v-radio-group v-model="radioCardValue" hide-details>
                      <v-row
                        no-gutters
                        v-for="source in userSources"
                        :key="source.id"
                      >
                        <v-col cols="12">
                          <v-radio :value="source.type">
                            <template v-slot:label>
                              <v-row no-gutters v-if="source.type === 'card'">
                                <span
                                  class="paymentTypesText textType2--text pl-2"
                                  style="padding-top: 2px"
                                >
                                  {{
                                    $t(
                                      'message.pages.credits.creditsPaymentModal.creditCard'
                                    )
                                  }}
                                  {{ capitalizeFirstLetter(source.brand) }}
                                  ({{
                                    $t(
                                      'message.pages.credits.creditsBuyModal.final'
                                    )
                                  }}
                                  {{ source.last4 }})
                                </span>
                              </v-row>
                              <v-row v-else no-gutters>
                                <span
                                  class="paymentTypesText textType2--text pl-2"
                                >
                                  {{
                                    source.type === 'newCard'
                                      ? $t(
                                          'message.pages.credits.creditsPaymentModal.newCard'
                                        )
                                      : source.type === 'pix'
                                      ? 'PIX'
                                      : 'Boleto'
                                  }}
                                </span>
                              </v-row>
                            </template>
                          </v-radio>
                        </v-col>
                        <v-col
                          v-if="
                            source.type === 'newCard' &&
                            radioCardValue === 'newCard'
                          "
                          cols="12"
                          class="pl-11"
                        >
                          <v-row no-gutters style="width: 300px">
                            <v-col cols="12" class="mt-1">
                              <stripe-element-card
                                key="creditStripeCard"
                                id="creditStripeCard"
                                ref="creditStripeCard"
                                :hidePostalCode="true"
                                :pk="stripeKeyByCountry"
                                @token="handleToken"
                                @keydown.enter="() => {}"
                              />
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          v-if="source.id !== 'boleto'"
                          cols="12"
                          class="my-3"
                        >
                          <v-divider />
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                  <base-btn
                    v-if="!isMobileBreakpoint"
                    class="mt-4"
                    style="width: 200px"
                    color="#3F55EE"
                    :disabled="loadings.saveCredits"
                    :loading="loadings.saveCredits"
                    @click="handleAddCredit"
                  >
                    <span>{{
                      $t('message.pages.credits.creditsBuyModal.confirmPayment')
                    }}</span>
                  </base-btn>
                  <span
                    v-if="!isMobileBreakpoint"
                    class="nonRefundableText textType10--text mt-2"
                  >
                    {{
                      $t('message.pages.credits.creditsBuyModal.nonRefundable')
                    }}
                  </span>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-else no-gutters style="overflow: visible">
          <v-card
            class="d-flex flex-row align-center justify-center banner mb-4"
            :class="isMobileBreakpoint ? 'mobile-banner' : ''"
          >
            <v-row
              no-gutters
              :class="`${
                isMobileBreakpoint
                  ? 'align-start justify-start flex-column px-4'
                  : 'align-center justify-center'
              }`"
              class
            >
              <v-row>
                <BlackFridayBanner :isBannerModal="true" class="w-100" />
              </v-row>
            </v-row>
          </v-card>

          <div :class="{ 'mobile-cards-container': isMobileBreakpoint }">
            <v-row
              no-gutters
              :class="{ 'flex-nowrap': isMobileBreakpoint }"
              style="overflow: visible !important"
            >
              <v-card
                v-for="(offer, i) in optionsValues"
                :key="i"
                class="px-4 py-5 d-flex elevation-0"
                :class="`${
                  $vuetify.theme.dark && selectedCard === i
                    ? 'darkModeSelectedCard'
                    : ''
                } ${isMobileBreakpoint ? 'mr-3 ' : 'mr-2 '}
                ${$vuetify.theme.dark ? 'card-wrapper' : ''}`"
                :width="isMobileBreakpoint ? '160px' : '170px'"
                :height="isMobileBreakpoint ? '480px' : '368px'"
                style="cursor: pointer"
                :style="
                  $vuetify.theme.dark
                    ? 'border: 1px solid #363949;'
                    : selectedCard === i
                    ? 'border: 1px solid #A0ACFF !important;'
                    : 'border: 1px solid #EDEEF1 !important;'
                "
                @click="handleCard(i)"
              >
                <div style="display: none"></div>
                <div
                  v-if="offer.discount"
                  :class="`discount-badge ${
                    $vuetify.theme.dark ? 'discount-badge-dark' : ''
                  }`"
                >
                  {{ offer.discount }}
                  {{ $t('message.pages.credits.creditsBuyModal.discount') }}
                </div>
                <v-row no-gutters class="flex-column">
                  <div class="flex-grow-1">
                    <div>
                      <v-row no-gutters align="center" justify="center">
                        <div class="pt-1">
                          <v-row no-gutters class="align-center justify-center">
                            <v-img
                              height="24"
                              width="24"
                              src="@/assets/credit_buy_modal_icon.svg"
                              contain
                            />
                            <span class="ml-1 pt-2">
                              <span class="creditsPrice text-center">{{
                                offer.amount.toLocaleString('pt-BR')
                              }}</span>
                              <br />
                              <span class="creditsTextPrice text-center">{{
                                $t(
                                  'message.pages.credits.creditsBuyModal.credits'
                                )
                              }}</span>
                            </span>
                          </v-row>
                        </div>
                      </v-row>
                    </div>
                    <v-divider class="my-5" />
                    <span
                      class="mb-3 text-center d-block offerDescription textType8--text"
                    >
                      {{
                        $t(
                          'message.pages.credits.creditsBuyModal.aiTimeContent'
                        ).replace('XXX', offer.aiTime)
                      }}
                    </span>
                    <span
                      class="text-center d-block textType9--text offerDescription"
                    >
                      {{
                        $t('message.pages.credits.creditsBuyModal.description')
                      }}
                    </span>
                    <v-divider class="mt-5" />
                  </div>
                  <v-row
                    no-gutters
                    class="price-container mx-auto justify-center align-center mb-2"
                  >
                    <span
                      v-if="offer.originalPrice"
                      class="original-price textType4--text mr-2"
                    >
                      {{ formatCurrency(offer.originalPrice) }}
                    </span>
                    <span class="priceText d-block texType3--text">
                      {{ formatCurrency(offer.price) }}
                    </span>
                  </v-row>
                  <base-btn
                    :style="`
                      height: 32px !important;
                      ${
                        $vuetify.theme.dark
                          ? 'background-color: #000000 !important;'
                          : ''
                      }
                      `"
                    type="secondary"
                    class="align-self-center"
                    @click="handleBuyClick(offer)"
                  >
                    {{ $t('message.pages.credits.creditsBuyModal.buy') }}
                  </base-btn>
                </v-row>
              </v-card>

              <v-card
                class="d-flex flex-column px-4 py-5 elevation-0"
                :class="`${
                  $vuetify.theme.dark && selectedCard === 99
                    ? 'darkModeSelectedCard'
                    : ''
                } ${isMobileBreakpoint ? 'mr-3 ' : 'mr-2 '}
                ${$vuetify.theme.dark ? 'card-wrapper' : ''}`"
                :width="isMobileBreakpoint ? '160px' : '170px'"
                :height="isMobileBreakpoint ? '420px' : '368px'"
                style="cursor: pointer"
                :style="
                  $vuetify.theme.dark
                    ? 'border: 1px solid #363949;'
                    : selectedCard === 99
                    ? 'border: 1px solid #A0ACFF !important;'
                    : 'border: 1px solid #EDEEF1 !important;'
                "
                @click="selectedCard = 99"
              >
                <div style="display: none"></div>
                <div
                  v-if="customValueDiscount"
                  :class="`discount-badge ${
                    $vuetify.theme.dark ? 'discount-badge-dark' : ''
                  }`"
                >
                  {{ customValueDiscount }}
                  {{ $t('message.pages.credits.creditsBuyModal.discount') }}
                </div>
                <v-row no-gutters class="flex-column">
                  <div class="flex-grow-1">
                    <span
                      class="mt-5 mb-1 textType--text pr-2 otherText text-center d-block"
                      >{{
                        $t(
                          'message.pages.credits.creditsPaymentModal.otherValue'
                        )
                      }}</span
                    >
                    <div class="mb-4" style="margin-top: 34px">
                      <v-divider />
                    </div>
                    <span class="creditsQuantity textType6--text">
                      {{
                        $t(
                          'message.pages.credits.creditsBuyModal.howManyCredits'
                        )
                      }}
                    </span>
                    <v-text-field
                      v-model="creditValue"
                      type="number"
                      min="5"
                      max="15000"
                      :error-messages="validationError"
                      @input="validateInput"
                      @keydown="preventUnwantedKeys"
                      @focus="handleUnwantedKey('focus')"
                      @blur="handleUnwantedKey('blur')"
                      :class="`quantityTextField ${
                        $vuetify.theme.dark ? 'creditsAmountField' : ''
                      }`"
                      outlined
                      dense
                      :placeholder="
                        !isMobileBreakpoint
                          ? $t('message.pages.credits.creditsBuyModal.typeHere')
                          : ''
                      "
                    >
                      <template v-slot:prepend-inner>
                        <v-img
                          width="16"
                          height="16"
                          src="@/assets/credit_buy_modal_icon.svg"
                          contain
                          :style="{
                            filter: $vuetify.theme.dark
                              ? 'invert(52%) sepia(11%) saturate(754%) hue-rotate(191deg) brightness(91%) contrast(87%)'
                              : 'none',
                            marginTop: '4px',
                          }"
                        />
                      </template>
                    </v-text-field>
                    <v-row
                      no-gutters
                      class="price-container mx-auto justify-center align-center"
                      style="margin-top: 74px"
                    >
                      <span
                        v-if="originalCustomValue"
                        class="original-price textType4--text mr-2"
                      >
                        {{ formatCurrency(originalCustomValue) }}
                      </span>
                      <span class="priceText d-block texType3--text">
                        {{ formatCurrency(discountedCustomValue) }}
                      </span>
                    </v-row>
                  </div>
                  <base-btn
                    :style="`
                      height: 32px !important;
                      ${
                        $vuetify.theme.dark
                          ? 'background-color: #000000 !important;'
                          : ''
                      }
                      `"
                    type="secondary"
                    class="align-self-center"
                    @click="
                      handleBuyClick({
                        amount: creditValue,
                        price: discountedCustomValue,
                        isOtherValue: true,
                      })
                    "
                  >
                    {{ $t('message.pages.credits.creditsBuyModal.buy') }}
                  </base-btn>
                </v-row>
              </v-card>
            </v-row>
          </div>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import planApi from '@/services/planApi'
import creditsApi from '@/services/creditsApi'
import i18n from '@/translations/lang'
import { StripeElementCard } from '@vue-stripe/vue-stripe'
import BlackFridayBanner from '@/components/BlackFridayBanner.vue'

export default {
  name: 'CreditsBuyModal',
  components: {
    StripeElementCard,
    BlackFridayBanner,
  },
  data: () => ({
    optionsValues: [
      {
        amount: 100,
        aiTime: 1,
        price: 100,
      },
      {
        amount: 500,
        aiTime: 8,
        price: 500,
      },
      {
        amount: 1000,
        aiTime: 16,
        originalPrice: 1000,
        price: 900,
        discount: '10%',
      },
      {
        amount: 5000,
        aiTime: 83,
        originalPrice: 5000,
        price: 4250,
        discount: '15%',
      },
    ],
    open: false,
    loadings: {
      saveCredits: false,
      getCardsLoading: false,
      brazilPayments: false,
    },
    creditValue: null,
    payment: {
      type: 'card',
    },
    selectedCard: 1,
    userSources: [],
    defaultSource: null,
    radioCardValue: null,
    currencyLocale: 'pt-BR',
    stripeKey: process.env.VUE_APP_STRIPE_API,
    stripeKeyUS: process.env.VUE_APP_STRIPE_API_US,
    pendingPayment: false,
    paymentDone: false,
    qrCodeSource: '',
    paymentText: '',
    boletoPdfUrl: '',
    errors: {
      fetchData: false,
      fetchError: false,
      shownErrMsg: 'Error',
      tooltipErrMsg: 'Error',
    },
    cardErrors: {
      declined: false,
      default: false,
      expired: false,
    },
    formattedTime: '',
    paymentStep: false,
    boletoOption: null,
    cardOption: null,
    validationError: '',
  }),
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    currency() {
      return this.userPlanInfo.currency ?? 'brl'
    },
    stripeKeyByCountry() {
      if (this.userPlanInfo?.currency === 'brl') return this.stripeKey
      return this.stripeKeyUS
    },
    formattedCreditValue() {
      let amount = this.creditValue
      if (amount >= 1000 && amount < 5000) {
        amount = amount * 0.9
      } else if (amount >= 5000) {
        amount = amount * 0.85
      }
      return amount
    },
    customValueDiscount() {
      if (!this.creditValue) return null
      const value = Number(this.creditValue)
      if (value >= 5000) return '15%'
      if (value >= 1000) return '10%'
      return null
    },
    originalCustomValue() {
      if (!this.customValueDiscount) return null
      return Number(this.creditValue)
    },
    discountedCustomValue() {
      if (!this.creditValue) return 0
      const value = Number(this.creditValue)
      if (value >= 5000) return value * 0.85
      if (value >= 1000) return value * 0.9
      return value
    },
    textFieldBackground() {
      return this.$vuetify.theme.dark ? '#000000' : '#FFFFFF'
    },
    helpArticleUrl() {
      const lang = this.$i18next.language
      if (lang === 'pt' || lang === 'pt-BR') {
        return 'https://help.pandavideo.com/pt-br/article/creditos-em-dobro-black-november-1kenzp0/'
      }
      if (lang === 'es') {
        return 'https://help.pandavideo.com/es/article/creditos-dobles-black-november-p4gg5n/'
      }
      return 'https://help.pandavideo.com/en-us/article/double-credits-black-november-qvnz74/'
    },
  },
  mounted() {
    this.$root.$on('creditsBuyModal', () => {
      this.getCards()
      Object.assign(this.$data, this.initialState())
      this.setCurrencyConfig()
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('creditsBuyModal')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('session', ['signInUser', 'fetchSession']),
    handleBackToPayment() {
      this.errors.fetchError = false
    },
    setCurrencyConfig() {
      if (this.currency === 'usd') {
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currencyLocale = 'pt-BR'
      }
    },
    handleCard(i) {
      this.selectedCard = i
    },
    handleOther() {
      this.selectedCard = 99
    },
    async getCards() {
      this.loadings.getCardsLoading = true
      try {
        const { data } = await planApi.getCards()
        this.userSources = data.sources.filter(
          (source) => source.type === 'card' && source.default
        )
        this.userSources.push({ id: 'newCard', type: 'newCard' })

        if (this.currency === 'brl')
          this.userSources.push({ id: 'pix', type: 'pix' })

        this.boletoOption = data.sources.find((item) => item.type === 'boleto')
        if (this.boletoOption) this.userSources.push(this.boletoOption)

        const card = data.sources.find((item) => item.default === true)
        this.cardOption = card
        if (card.type === 'card') {
          this.defaultSource = card
          this.radioCardValue = card.id
        }
        this.loadings.getCardsLoading = false
      } catch (error) {
        this.loadings.getCardsLoading = false
        console.error('error', error)
      }
    },
    handleValidations() {
      this.errors.shownErrMsg = ''
      if (this.creditValue < 5) {
        // this.errors.fetchError = true
        this.errors.shownErrMsg =
          'O valor inserido é abaixo do valor de R$ 5,00 permitido'
        return false
      }
      if (this.creditValue > 15000) {
        // this.errors.fetchError = true
        this.errors.shownErrMsg =
          'O valor inserido é acima do valor de R$ 15,000 permitido'
        return false
      }
      return true
    },
    async handleAddCredit() {
      this.clearErrors()
      let validation = this.handleValidations()
      if (!validation) return
      this.loadings.saveCredits = true
      let response = await this.addCreditApi()
      if (!response?.data) return
      this.formattedTime = this.formatDate()
      if (this.radioCardValue === 'pix') {
        const stripe = window.Stripe(this.stripeKey)
        this.loadings.brazilPayments = true
        try {
          let ret = await stripe.confirmPixPayment(
            response.data.client_secret,
            {},
            { handleActions: false }
          )
          this.qrCodeSource =
            ret.paymentIntent.next_action.pix_display_qr_code.image_url_png
          this.paymentText =
            ret.paymentIntent.next_action.pix_display_qr_code.data
          setTimeout(() => {
            this.pendingPayment = true
          }, 1000)
          this.loadings.brazilPayments = false
        } catch (e) {
          this.handleFetchError(e)
        }
      }
      if (this.radioCardValue === 'boleto') {
        this.loadings.brazilPayments = true
        const stripe = window.Stripe(this.stripeKey)
        try {
          let ret = await stripe.confirmBoletoPayment(
            response.data.client_secret,
            {
              payment_method: {
                boleto: {
                  tax_id: this.boletoOption.tax_id,
                },
                billing_details: this.boletoOption.billing_details,
              },
            },
            { handleActions: false }
          )
          this.paymentText =
            ret.paymentIntent.next_action.boleto_display_details.number
          this.boletoPdfUrl =
            ret.paymentIntent.next_action.boleto_display_details.pdf
          setTimeout(() => {
            this.pendingPayment = true
          }, 1000)
          this.loadings.brazilPayments = false
        } catch (e) {
          this.handleFetchError(e)
        }
      }
      this.$root.$emit('updateCreditsList')
      this.loadings.saveCredits = false
    },
    async addCreditApi(cardId) {
      let data = {
        amount: this.creditValue,
        currency: 'brl',
        method:
          this.radioCardValue === 'newCard' ? 'card' : this.radioCardValue,
      }
      if (this.radioCardValue === 'card' || this.radioCardValue === 'newCard') {
        if (this.radioCardValue === 'newCard' && !cardId) {
          const cardRef =
            this.$refs.creditStripeCard[0] || this.$refs.creditStripeCard
          await cardRef.submit()
          return
        } else if (cardId) {
          data['payment_method_id'] = cardId
        } else {
          data['payment_method_id'] = this.cardOption.id
        }
      }
      try {
        const res = await creditsApi.addCredit(data)
        this.paymentDone = true
        return res
      } catch (e) {
        this.handleFetchError(e)
        console.error(e)
      }
    },
    async handleToken(token) {
      this.loadings.saveCredits = true
      try {
        await this.addCardToUser(token)
      } catch (error) {
        console.log(error)
      }
    },
    async addCardToUser(cardToken) {
      Object.keys(this.cardErrors).forEach((e) => (this.cardErrors[e] = false))
      try {
        let ret = await planApi.addCard(cardToken)
        let registeredCards = ret.data.filter(
          (source) => source.type === 'card'
        )
        const newCard = registeredCards.find((card) => {
          return !this.userSources.some((prevCard) => prevCard.id === card.id)
        })
        this.addCreditApi(newCard.id)
      } catch (e) {
        this.handleFetchError(e)
        switch (e.response.data.errMsg) {
          case 'card_declined':
            this.cardErrors.declined = true
            break
          case 'expired_card':
            this.cardErrors.expired = true
            break
          default:
            this.cardErrors.default = true
            break
        }
      }
    },
    handleFetchError(err) {
      this.loadings.saveCredits = false
      this.errors.shownErrMsg = i18n.t('message.errors.unexpectedError')
      let errString = ''
      if (
        err?.response?.data &&
        err?.response?.data?.errMsg &&
        err?.response?.data?.errCode
      ) {
        errString = err.response.data.errCode + err.response.data.errMsg
      }
      this.errors.tooltipErrMsg =
        err.msg ?? errString ?? err.response.data.message ?? err ?? 'Error'
      this.errors.fetchError = true
    },
    handleCopyPaymentCode() {
      const item = this.paymentText
      navigator.clipboard.writeText(`${item}`)
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: 'Copiado com sucesso!',
      })
    },
    handleOpenBoletoPdf() {
      window.open(this.boletoPdfUrl, '_blank')
    },
    handleCreditsHistory() {
      this.$router.push({ name: 'Credits' }).catch(() => {})
      this.handleClose()
    },
    capitalizeFirstLetter(string) {
      if (!string) return
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => {
        if (typeof this.errors[e] === 'string') {
          return (this.errors[e] = '')
        }
        this.errors[e] = false
      })
    },
    formatDate() {
      let timestamp = Date.now()
      const date = new Date(timestamp)
      // Get day, month and year
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear().toString()
      // Get hours and minutes
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      // Format the date string
      const formattedDate = `${day}/${month}/${year} ${i18n.t(
        'message.pages.credits.creditsBuyModal.at'
      )} ${hours}h${minutes}`
      return formattedDate
    },
    handleClose() {
      this.open = false
    },
    initialState() {
      return {
        optionsValues: [
          {
            amount: 100,
            aiTime: 1,
            price: 100,
          },
          {
            amount: 500,
            aiTime: 8,
            price: 500,
          },
          {
            amount: 1000,
            aiTime: 16,
            originalPrice: 1000,
            price: 900,
            discount: '10%',
          },
          {
            amount: 5000,
            aiTime: 83,
            originalPrice: 5000,
            price: 4250,
            discount: '15%',
          },
        ],
        open: false,
        loadings: {
          saveCredits: false,
          getCardsLoading: false,
          brazilPayments: false,
        },
        creditValue: null,
        payment: {
          type: 'card',
        },
        selectedCard: 1,
        userSources: [],
        defaultSource: null,
        radioCardValue: null,
        currencyLocale: 'pt-BR',
        stripeKey: process.env.VUE_APP_STRIPE_API,
        stripeKeyUS: process.env.VUE_APP_STRIPE_API_US,
        pendingPayment: false,
        paymentDone: false,
        qrCodeSource: '',
        paymentText: '',
        boletoPdfUrl: '',
        errors: {
          fetchData: false,
          fetchError: false,
          shownErrMsg: 'Error',
          tooltipErrMsg: 'Error',
        },
        cardErrors: {
          declined: false,
          default: false,
          expired: false,
        },
        formattedTime: '',
        paymentStep: false,
        boletoOption: null,
        cardOption: null,
      }
    },
    preventUnwantedKeys(event) {
      if ([',', '-', '+', 'e', 'E'].includes(event.key)) {
        event.preventDefault()
      }
    },
    handleUnwantedKey(inputEvent) {
      const isFocused = inputEvent === 'focus'
      isFocused ? this.addKeyListener() : this.removeKeyListener()
    },
    addKeyListener() {
      window.addEventListener('keydown', this.preventUnwantedKeys)
    },
    removeKeyListener() {
      window.removeEventListener('keydown', this.preventUnwantedKeys)
    },
    formatCurrency(value) {
      if (!value) return ''
      return value.toLocaleString(this.currencyLocale, {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    },
    handleBuyClick(selectedOffer) {
      if (
        selectedOffer.isOtherValue &&
        (this.creditValue < 5 || this.creditValue > 15000)
      ) {
        return
      }

      this.paymentStep = true
      this.creditValue = selectedOffer.amount
      this.selectedAmount = selectedOffer.price
      this.clearErrors()
      this.radioCardValue = null
      this.$nextTick(() => {
        this.radioCardValue = ''
      })
    },
    validateInput(value) {
      // Limita o input a 7 dígitos
      if (value && value.toString().length > 7) {
        this.creditValue = value.toString().slice(0, 7)
        return
      }

      this.creditValue = value

      if (!value) {
        this.validationError = ''
      } else if (value < 5) {
        this.validationError = this.$i18next.t(
          'message.pages.credits.creditsBuyModal.minValueError'
        )
      } else if (value > 15000) {
        this.validationError = this.$i18next.t(
          'message.pages.credits.creditsBuyModal.maxValueError'
        )
      } else {
        this.validationError = ''
      }

      // Atualiza o estado de erro global se necessrio
      // this.errors.fetchError = !!this.validationError
      this.errors.shownErrMsg = this.validationError
    },
    openHelpArticle() {
      window.open(this.helpArticleUrl, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-summary {
  order: 1;
}
.payment-form {
  order: 2;
}

.darkModeSelectedCard {
  border-radius: 4px !important;
  border: 1px solid #0a21c2 !important;
  background: #051161 !important;
}

.titleText {
  font-size: 18px;
  font-weight: 500;
  line-height: 120%;
  @media only screen and (max-width: 960px) {
    font-size: 14px !important;
  }
}
.mainText {
  font-size: 24px;
  font-weight: 500;
  line-height: 120%; /* 28.8px */
  @media only screen and (max-width: 960px) {
    font-size: 18px !important;
  }
}
.priceText {
  font-size: 14px;
  font-weight: 500;
  line-height: 150%; /* 21px */
}
.otherText {
  font-size: 16px;
  font-weight: 500;
  @media only screen and (max-width: 960px) {
    font-size: 13px !important;
  }
}

.optionsText {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 100%; /* 16px */
  font-style: normal;
  text-transform: none !important;
  letter-spacing: 0.5px;
  @media only screen and (max-width: 960px) {
    font-size: 13px !important;
  }
}
.paymentText {
  font-size: 16px;
  font-weight: 500;
  line-height: 150%; /* 24px */
  @media only screen and (max-width: 960px) {
    font-size: 13px !important;
  }
}
.cardText {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.02em;
  @media only screen and (max-width: 960px) {
    font-size: 13px !important;
  }
}
.quantityTextField {
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
}
.wrapText {
  word-break: break-word;
}

.dateText {
  font-size: 12px;
  font-weight: 400;
  line-height: 150%; /* 18px */
  @media only screen and (max-width: 960px) {
    font-size: 10px !important;
  }
}
.paymentCodeText {
  font-size: 14px;
  font-weight: 400px;
  @media only screen and (max-width: 960px) {
    font-size: 12px !important;
  }
}
.banner {
  width: 100%;
  height: 105px;
  padding: 0px;
  background: linear-gradient(263deg, #425af0 22.15%, #182996 90.09%);
  border-radius: 8px;
}
.creditsPrice {
  font-size: 24px;
  font-weight: 500;
  line-height: 70%;
}
.creditsTextPrice {
  font-size: 11px;
  font-weight: 400;
  line-height: 70%;
  letter-spacing: 0.66px;
  text-transform: uppercase;
}
.offerDescription {
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}
.bfBtn {
  border-radius: 8px;
  border: 1px solid #7283f3;
  background: #040a2f;
  box-shadow: 0px 0px 24px 0px rgba(114, 131, 243, 0.7);
}
.bannerTitle {
  font-size: 18px;
  font-weight: 500;
  line-height: 120%;
}
.bannerSubtitle {
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}
.creditsQuantity {
  font-size: 12px;
  font-weight: 500;
}

.card-wrapper {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background-color: #1e1e1e;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.2);
  }
}

.credits-title {
  font-size: 24px;
  font-weight: 500;
  line-height: 120%;
}

.h-100 {
  height: 100%;
}

.creditsAmountField {
  ::v-deep .v-input__control .v-input__slot {
    background-color: #000000 !important;
  }
}

.discount-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #c8e6c9;
  color: #174f1b;
  padding: 2px 8px;
  border-radius: 16px !important;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  z-index: 2;
}

.discount-badge-dark {
  background-color: #1b5e20 !important;
  color: #dcefdd !important;
}

::v-deep .v-card .discount-badge {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}

::v-deep .v-card {
  overflow: visible !important;
}

::v-deep .v-dialog {
  overflow: visible !important;
}

::v-deep .v-card__text {
  overflow: visible !important;
}

.original-price {
  font-size: 11px;
  text-decoration: line-through;
}

.priceText {
  font-size: 13px;
  font-weight: 500;
}

.small-placeholder ::v-deep input::placeholder {
  font-size: 13px;
  color: #73778c; /* textType7 color */
}
.creditHistoryText {
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}
.knowMoreBtnText {
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}
.creditsAmountField ::v-deep .v-input__control .v-input__slot {
  background-color: black !important;
}
.cardSelectedBackground {
  background-color: #051161 !important;
}
.paymentMethodText {
  font-size: 11px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.66px;
  text-transform: uppercase;
}
.nonRefundableText {
  font-size: 12px;
  font-weight: 400;
}
.paymentTypesText {
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}

.mobile-cards-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  padding-top: 12px;

  &::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }
}

.mobile-banner {
  height: auto !important;
  padding: 16px 0 !important;

  .bannerTitle {
    font-size: 16px !important;
  }

  .bannerSubtitle {
    font-size: 14px !important;
  }
}

/* Ajuste para o step de pagamento no mobile */
@media only screen and (max-width: 960px) {
  .v-card-text {
    .v-row {
      &[style*='height: 420px'] {
        flex-direction: column !important;

        > .v-col {
          flex: 0 0 100% !important;
          max-width: 100% !important;
        }
      }
    }
  }

  .paymentMethodText {
    margin-top: 24px;
  }

  .v-text-field {
    width: 100% !important;
  }
}

.credits-amount {
  font-size: 24px;
  font-weight: 500;
  text-align: center;
}

.credits-label {
  display: block;
  font-size: 10px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.66px;
}
</style>
